import React from 'react';
import CustomModal from "../../components/Modal/CustomModal";

const GenericModal = (props) => {
    const {onHide, onConfirm, children, size="md"} = props;

    return (
        <CustomModal
            {...props}
            size={size}
            cancelButton={true}
            confirmButton={true}
            onConfirm={() => {
                onHide()
                onConfirm();
            }}
            classNameBody="pt-2"
        >
            {children}
        </CustomModal>
    );
};

export default GenericModal;
